/**
 * Veeroute.Lastmile
 * Veeroute Lastmile API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Groups of reasons:   * `SHORT_TIME_WINDOW` - Narrow time windows.   * `LACK_RESOURCE` - Not enough vehicles and performers.   * `LOW_ORDER_COMPATIBILITY` - Low order compatibility with each other.   * `LOW_RESOURCE_COMPATIBILITY` - Few compatible resources.   * `LOW_CAPACITY` - Lack of a resource with a certain capacity.   * `LACK_CAPACITY` - Insufficient vehicle capacity.   * `HUGE_PEAK_LOAD` - Large peak load on orders.   * `FAR_LOCATION` - Potentially problematic geo-location point.   * `FAR_ORDER` - Potentially bad order time window. 
 */
export enum AnalyticsCheckGroupTypeLastmile {
    SHORT_TIME_WINDOW = 'SHORT_TIME_WINDOW',
    LACK_RESOURCE = 'LACK_RESOURCE',
    LOW_ORDER_COMPATIBILITY = 'LOW_ORDER_COMPATIBILITY',
    LOW_RESOURCE_COMPATIBILITY = 'LOW_RESOURCE_COMPATIBILITY',
    LOW_CAPACITY = 'LOW_CAPACITY',
    LACK_CAPACITY = 'LACK_CAPACITY',
    HUGE_PEAK_LOAD = 'HUGE_PEAK_LOAD',
    FAR_LOCATION = 'FAR_LOCATION',
    FAR_ORDER = 'FAR_ORDER'
};

